export const WA_NUMBER = "6285692777370";
export const WA_LINK = `https://wa.me/${WA_NUMBER}`;
export const IG_HANDLE = "nusuabetta";
export const IG_LINK = `https://instagram.com/${IG_HANDLE}`;

export const translations = {
  id: {
    nav: {
      home: "Beranda",
      catalog: "Koleksi",
      location: "Lokasi",
      contact: "Kontak",
    },
    hero: {
      eyebrow: "Ikan Cupang Eksklusif · Indonesia",
      lines: [
        { text: "Jika makhluk ini", accent: false },
        { text: "memikat jiwamu,", accent: true },
        { text: "jangan ragu untuk", accent: false },
        { text: "menghubungi kami", accent: true },
      ],
      sub: "Bawa keindahan ekosistem air ke dalam rumah. Kami menyediakan berbagai jenis ikan cupang hias pilihan dengan kualitas warna dan kesehatan terpilih. Siap kirim ke seluruh Indonesia dengan garansi pengiriman.",
      ctaExplore: "Jelajahi Koleksi",
      ctaContact: "Hubungi Kami",
      badgeStrain: "Strain Pilihan",
      badgeGrade: "Grade A+",
      scroll: "Gulir ke bawah",
    },
    marquee: [
      "Grade A+ Betta Strains",
      "Garansi Ikan Hidup Sampai",
      "Seni Akuatik Eksklusif",
      "Nusua Betta",
      "Kurasi Warna Premium",
    ],
    values: [
      { title: "Grade A+", desc: "Ikan pilihan berkualitas" },
      { title: "100% Secure Payment", desc: "Pembayaran Aman & Terverifikasi" },
      { title: "Fast Shipping", desc: "Jaminan Pengiriman Tercepat" },
    ],
    catalog: {
      eyebrow: "Katalog",
      title: "Koleksi Strain Eksklusif",
      subtitle: "Setiap ekor dikurasi langsung — warna, mental, dan kesehatan terjaga.",
      filters: [
        { id: "all", label: "Semua" },
        { id: "Plakat", label: "Plakat" },
        { id: "Halfmoon", label: "Halfmoon" },
        { id: "Crowntail", label: "Crowntail" },
        { id: "Giant", label: "Giant" },
      ],
      addToCart: "Tambah ke Keranjang",
      buyNow: "Beli Sekarang",
      grade: "Grade A+",
      viewDetail: "Lihat Detail",
      photos: "foto",
      video: "video",
      available: "Tersedia",
      sold: "Terjual",
    },
    product: {
      eyebrow: "Detail Produk",
      share: "Bagikan",
      shareMsg: "Lihat ikan cupang ini di Nusua Betta:",
      copied: "Tautan disalin — tempel di Instagram Story/DM kamu",
      copyLink: "Salin Tautan",
      soldNote: "Ikan ini sudah terjual. Hubungi kami untuk strain serupa.",
      loading: "Memuat koleksi eksklusif",
      about: "Tentang Ikan Ini",
      specs: "Spesifikasi",
      size: "Ukuran",
      age: "Usia",
      sex: "Kelamin",
      tail: "Tipe Ekor",
      months: "bulan",
      male: "Jantan",
      female: "Betina",
      qty: "Jumlah",
      ask: "Tanya via WhatsApp",
      askMsg: "Halo Nusua Betta! Saya tertarik dengan",
      gallery: "Galeri",
      swipe: "Geser untuk foto lainnya",
      close: "Tutup",
      guarantee: "Garansi ikan hidup sampai · Kirim seluruh Indonesia",
    },
    cart: {
      title: "Keranjang Belanja",
      empty: "Keranjangmu masih kosong.",
      emptyCta: "Lihat Koleksi",
      subtotal: "Subtotal",
      note: "Siap kirim ke seluruh Indonesia dengan garansi ikan hidup sampai.",
      checkout: "Lanjut ke Checkout",
    },
    checkout: {
      title: "Checkout Pesanan",
      subtitle: "Lengkapi data berikut — pesanan diteruskan langsung ke WhatsApp kami.",
      name: "Nama Lengkap",
      namePh: "Nama kamu",
      phone: "No. HP",
      phonePh: "08xxxxxxxxxx",
      address: "Alamat Kirim",
      addressPh: "Jalan, kota, kode pos",
      proofLabel: "Upload Bukti Foto",
      proofHint: "Opsional — file tidak disimpan, lampirkan kembali saat chat WhatsApp.",
      proofButton: "Pilih File",
      proofNone: "Belum ada file dipilih",
      payment: "Metode Pembayaran",
      summary: "Ringkasan Pesanan",
      total: "Total",
      confirm: "Konfirmasi Pesanan",
      confirmNote: "Kamu akan diarahkan ke WhatsApp dengan rincian pesanan.",
      errRequired: "Mohon lengkapi nama, no. HP, dan alamat kirim.",
      errEmpty: "Keranjang masih kosong.",
    },
    location: {
      eyebrow: "Kunjungi Kami",
      title: "Puppy Nusantara Store",
      address: "PMQX+H7 Pd. Kacang Tim., Kota Tangerang Selatan, Banten",
      hoursLabel: "Jam Operasional",
      hours: "Buka · Tutup pukul 00.00",
      instagramLabel: "Instagram",
      whatsappCta: "Chat WhatsApp",
      busyTitle: "Jam Ramai Pengunjung",
      busySubtitle: "Perkiraan kepadatan toko per jam",
      days: { fri: "Jumat", sun: "Minggu" },
      peak: "Tersibuk",
    },
    footer: {
      tagline: "Seni hidup dalam akuarium — ikan cupang Grade A+ pilihan, dari Tangerang Selatan untuk seluruh Indonesia.",
      rights: "© 2026 Nusua Betta. Seluruh hak cipta dilindungi.",
    },
    toast: { added: "Ditambahkan ke keranjang" },
    wa: {
      greeting: "Halo Nusua Betta! Saya ingin memesan:",
      total: "Total",
      name: "Nama",
      phone: "No HP",
      address: "Alamat Kirim",
      payment: "Pembayaran",
      proof: "Bukti pembayaran: akan saya kirimkan di chat ini",
      closing: "Mohon konfirmasi pesanan saya. Terima kasih!",
    },
  },
  en: {
    nav: {
      home: "Home",
      catalog: "Collection",
      location: "Location",
      contact: "Contact",
    },
    hero: {
      eyebrow: "Exclusive Betta Fish · Indonesia",
      lines: [
        { text: "If this creature", accent: false },
        { text: "binds your soul,", accent: true },
        { text: "feel free to", accent: false },
        { text: "contact us", accent: true },
      ],
      sub: "Bring the beauty of the aquatic ecosystem into your home. We provide various selected ornamental fish species with guaranteed color quality and health. Ready to ship throughout Indonesia with a live arrival guarantee!",
      ctaExplore: "Explore Collection",
      ctaContact: "Contact Us",
      badgeStrain: "Selected Strain",
      badgeGrade: "Grade A+",
      scroll: "Scroll down",
    },
    marquee: [
      "Grade A+ Betta Strains",
      "Live Arrival Guarantee",
      "Exclusive Aquatic Artistry",
      "Nusua Betta",
      "Premium Color Curation",
    ],
    values: [
      { title: "Grade A+", desc: "Premium selected fish" },
      { title: "100% Secure Payment", desc: "Safe & verified payments" },
      { title: "Fast Shipping", desc: "Fastest delivery guarantee" },
    ],
    catalog: {
      eyebrow: "Catalog",
      title: "Exclusive Strain Collection",
      subtitle: "Each fish is hand-curated — color, spirit, and health guaranteed.",
      filters: [
        { id: "all", label: "All" },
        { id: "Plakat", label: "Plakat" },
        { id: "Halfmoon", label: "Halfmoon" },
        { id: "Crowntail", label: "Crowntail" },
        { id: "Giant", label: "Giant" },
      ],
      addToCart: "Add to Cart",
      buyNow: "Buy Now",
      grade: "Grade A+",
      viewDetail: "View Details",
      photos: "photos",
      video: "video",
      available: "Available",
      sold: "Sold Out",
    },
    product: {
      eyebrow: "Product Details",
      share: "Share",
      shareMsg: "Check out this betta at Nusua Betta:",
      copied: "Link copied — paste it in your Instagram Story/DM",
      copyLink: "Copy Link",
      soldNote: "This fish has been sold. Contact us for a similar strain.",
      loading: "Loading exclusive collection",
      about: "About This Fish",
      specs: "Specifications",
      size: "Size",
      age: "Age",
      sex: "Sex",
      tail: "Tail Type",
      months: "months",
      male: "Male",
      female: "Female",
      qty: "Quantity",
      ask: "Ask on WhatsApp",
      askMsg: "Hello Nusua Betta! I'm interested in",
      gallery: "Gallery",
      swipe: "Swipe for more photos",
      close: "Close",
      guarantee: "Live arrival guarantee · Ships across Indonesia",
    },
    cart: {
      title: "Shopping Cart",
      empty: "Your cart is still empty.",
      emptyCta: "Browse Collection",
      subtotal: "Subtotal",
      note: "Ships across Indonesia with live arrival guarantee.",
      checkout: "Proceed to Checkout",
    },
    checkout: {
      title: "Order Checkout",
      subtitle: "Complete the details below — your order is forwarded straight to our WhatsApp.",
      name: "Full Name",
      namePh: "Your name",
      phone: "Phone Number",
      phonePh: "08xxxxxxxxxx",
      address: "Shipping Address",
      addressPh: "Street, city, postal code",
      proofLabel: "Upload Photo Proof",
      proofHint: "Optional — file is not stored, re-attach it in the WhatsApp chat.",
      proofButton: "Choose File",
      proofNone: "No file selected",
      payment: "Payment Method",
      summary: "Order Summary",
      total: "Total",
      confirm: "Confirm Order",
      confirmNote: "You will be redirected to WhatsApp with your order details.",
      errRequired: "Please complete name, phone, and shipping address.",
      errEmpty: "Your cart is empty.",
    },
    location: {
      eyebrow: "Visit Us",
      title: "Puppy Nusantara Store",
      address: "PMQX+H7 Pd. Kacang Tim., South Tangerang City, Banten",
      hoursLabel: "Opening Hours",
      hours: "Open · Closes at 00.00",
      instagramLabel: "Instagram",
      whatsappCta: "Chat on WhatsApp",
      busyTitle: "Peak Busy Hours",
      busySubtitle: "Estimated store traffic per hour",
      days: { fri: "Friday", sun: "Sunday" },
      peak: "Busiest",
    },
    footer: {
      tagline: "Living art in an aquarium — curated Grade A+ betta fish, from South Tangerang to all of Indonesia.",
      rights: "© 2026 Nusua Betta. All rights reserved.",
    },
    toast: { added: "Added to cart" },
    wa: {
      greeting: "Hello Nusua Betta! I would like to order:",
      total: "Total",
      name: "Name",
      phone: "Phone",
      address: "Shipping Address",
      payment: "Payment",
      proof: "Payment proof: I will send it in this chat",
      closing: "Please confirm my order. Thank you!",
    },
  },
};
